module.exports = __webpack_public_path__ + "assets/img/btn-view-2e5146dc.png";